import React from "react";
import { Box, Typography, BoxProps } from "@material-ui/core";
import { FinancialLoader } from "./FinancialLoader";
import { PageLink } from "../../../components/CustomLink";

interface FinancialDetailProps extends BoxProps {
  title: string;
  subtitles?: string[];
  link?: LinkTo;
  loading: boolean;
}

export interface LinkTo {
  text: string;
  path: string;
}

export const FinancialDetail: React.FC<FinancialDetailProps> = ({
  title,
  subtitles,
  link,
  children,
  loading,
  ...props
}) => {
  return (
    <Box {...props}>
      <Typography variant="body1" color="textSecondary">
        {title}
      </Typography>
      {loading ? (
        <FinancialLoader data-testid="FinancialDetail__Loader" />
      ) : (
        <>
          {children && <Box mb={0.5}>{children}</Box>}
          {subtitles && (
            <Box mb={1}>
              {subtitles.map((subtitle) => (
                <Box mb={0.75} key={subtitle}>
                  <Typography variant="subtitle1" color="textPrimary">
                    {subtitle}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </>
      )}
      {link && (
        <PageLink
          path={link.path}
          text={link.text}
          data-testid="FinancialDetail__Action"
        />
      )}
    </Box>
  );
};
